module.exports = __webpack_public_path__ + "img/bjhy@2x.d41a8b2c.png";